import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';


let firebaseConfig = {
    apiKey            : process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain        : process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL       : process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId         : process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket     : process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId : process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId             : process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const fire = firebase.initializeApp(firebaseConfig);

export default fire;